import JsonEncodeInput from './JsonEncodeInput';

const filter = {
  name: 'JSON encode',
  Input: JsonEncodeInput,
  content: {},
  format: (variable) => {
    return `${variable}|json_encode`;
  },
  valid: () => true
};

export default filter;
